__turbopack_context__.v({
  "axis": "research-hero-module__FlC-sq__axis",
  "fourth": "research-hero-module__FlC-sq__fourth",
  "live": "research-hero-module__FlC-sq__live",
  "minimum": "research-hero-module__FlC-sq__minimum",
  "panel": "research-hero-module__FlC-sq__panel",
  "ping": "research-hero-module__FlC-sq__ping",
  "point": "research-hero-module__FlC-sq__point",
  "primary": "research-hero-module__FlC-sq__primary",
  "readout": "research-hero-module__FlC-sq__readout",
  "research-blink": "research-hero-module__FlC-sq__research-blink",
  "research-ping": "research-hero-module__FlC-sq__research-ping",
  "research-rise": "research-hero-module__FlC-sq__research-rise",
  "result": "research-hero-module__FlC-sq__result",
  "rise": "research-hero-module__FlC-sq__rise",
  "second": "research-hero-module__FlC-sq__second",
  "third": "research-hero-module__FlC-sq__third",
});
